import type { SessionInitCommand } from "@skaile/workspaces/types";
import { parseCodexCredential } from "../../bridge/src/codex/credentials.js";
export {
  parseCodexCredential,
  parseCodexRefreshInput,
  parseCodexRefreshResult,
} from "../../bridge/src/codex/credentials.js";

/** Refuse unsupported managed initialization before reading or provisioning credential material. */
export function validateCodexInit(
  cmd: SessionInitCommand,
  supported: readonly string[],
  previous?: SessionInitCommand["identity"],
): void {
  const requirements = cmd.requiredRuntimeFeatures;
  if (
    requirements !== undefined &&
    (!Array.isArray(requirements) ||
      requirements.some((item) => typeof item !== "string" || !supported.includes(item)))
  )
    throw new Error("Unsupported runtime: required features are unavailable");
  const profile = cmd.resolvedConfig.agentConfig;
  const managed =
    profile?.driver === "codex" &&
    (profile.authMode !== undefined || requirements?.includes("codex-app-server-v1"));
  if ((managed || cmd.credentials.ai !== undefined) && !supported.includes("codex-app-server-v1"))
    throw new Error("Unsupported runtime: codex-app-server-v1 is unavailable");
  if (!managed && cmd.credentials.ai === undefined) return;
  if (
    previous &&
    ["containerId", "sessionId", "projectId", "ownerUserId"].some(
      (key) =>
        previous[key as keyof typeof previous] !== cmd.identity[key as keyof typeof previous],
    )
  )
    throw new Error("Invalid managed AI session identity");
  if (
    !managed ||
    profile?.provider !== "openai" ||
    !["subscription", "api-key"].includes(profile.authMode ?? "")
  )
    throw new Error("Invalid managed OpenAI profile");
  const credential = parseCodexCredential(cmd.credentials.ai);
  if (
    credential.configId !== cmd.resolvedConfig.aiProviderConfigId ||
    (profile.authMode === "subscription") !== (credential.kind === "codex-subscription")
  )
    throw new Error("Invalid managed AI credential binding");
  if (cmd.secrets && Object.keys(cmd.secrets).some((key) => /openai|codex/i.test(key)))
    throw new Error("Conflicting managed AI credential delivery");
}
